import { useSelector, useDispatch } from 'react-redux';
import { useLayoutEffect } from 'react';

import {
    getFlashMessages,
    fetchFlashMessages,
    getIsInitial,
    getClientFlashMessages,
} from './index';

export const useFlashMessagesWithPrefetch = () => {
    const dispatch = useDispatch();
    const messages = useSelector(getFlashMessages) || [];
    const isInitial = useSelector(getIsInitial);
    const clientFlashMessages = useSelector(getClientFlashMessages);

    useLayoutEffect(() => {
        if (isInitial) {
            dispatch(fetchFlashMessages());
        }
    }, []);

    return [...messages, ...clientFlashMessages];
};
